'use client'

import { SelectionItem } from '../../../domain/selectionItem'
import { useTranslation } from '../../context/ConfigContext'
import Image from '../Image/Image'
import { buildFullUrlMedia } from '../../../core/hook/utils'
import Link from '../Link/Link'
import clsx from 'clsx'

const Mosaic = (props: SelectionItem) => {
  const t = useTranslation()

  return (
    <article className={`mosaic ${props.className}`}>
      {props.videourl ? (
        <div className={`video-container`}>
          <video
            src={(props.videourl && buildFullUrlMedia(props.videourl)) ?? ''}
            muted
            autoPlay
            loop
            playsInline
            controls={false}
            poster={(props.contentimage && buildFullUrlMedia(props.contentimage)) ?? ''}></video>
        </div>
      ) : (
        <picture>
          <Image
            src={(props.contentimage && buildFullUrlMedia(props.contentimage)) ?? ''}
            alt=''
            aria-label={props.title}
          />
        </picture>
      )}

      <div className='content'>
        <h3 
          className={clsx('title-h3', { 'text-black': props.content_color === 1})}
          >
            {props.title}
        </h3>
        <div 
          className={clsx('content-text', { 'text-black': props.content_color === 1})} 
          dangerouslySetInnerHTML={{ __html: props.content ?? '' }} 
        />

        {props.link && (
          <Link 
            className={clsx('button', { 'border-black': props.content_color === 1, 'border-white': props.content_color !== 1})}
            href={props.link}>
              {t('global-cta-discover')}
          </Link>
        )}
      </div>
    </article>
  )
}

export default Mosaic
